export default __webpack_public_path__ + "static/media/3.da338dd2.jpg";